export default "__VITE_ASSET__06f960b5__"